import { gql } from "@apollo/client";import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { useForm } from '../../../components/hooks/useForm';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadIcon from '@mui/icons-material/Download';
import toast, { Toaster } from 'react-hot-toast';
import DocumentViewer from '../../../components/DocumentViewer';

import { APPCONFIG } from '../../../app.config';
import ErrorDialog from '../../../components/ErrorDialog';
import { CircularProgress } from "@mui/material";
import fileDownload from 'js-file-download';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { CustomButton } from '../../../components/customButton/CustomButton';

export default function Referenciados() {

  const RESULTADO_VALIDACION_OK = 'OK';
  const COLOR_OK = 'green';
  const COLOR_ERROR = 'red';

  const [result, setResult] = useState('-');
  const [colorMsg, setCologMsg] = useState('');

  const [data, setData] = useState([]);
  const [idArchivo, setIdArchivo] = useState(0);
  const [disabledBtnValidar, setDisabledBtnValidar] = useState(false);
  const [showGrilla, setShowGrilla] = useState(false);
  const [accion, setAccion] = useState('');

  // upload
  const [fileSelected, setFileSelected] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);

  // dlg visualización
  const [filePreview, setFilePreview] = useState([]);
  const [openDlg, setOpenDlg] = useState(false);

  // dlg confimración
  const [openDlgConfirm, setOpenDlgConfirm] = useState(false);

  // Log de errores
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  let toastId = 0;
  const textInputEvaluacion = useRef(null);

  const Input = styled('input')({
    display: 'none'
  });

  const [formValues, formHandle, setFormValues] = useForm({
    Evaluacion: ''
  });

  useEffect(() => {
    textInputEvaluacion.current.focus();
  }, []);

  const isValid = () => {
    let resultado = true;
    let mensaje = 'OK';

    // Remito
    if (formValues.Evaluacion === "") {
      textInputEvaluacion.current.focus();
      return {
        resultado: false,
        mensaje: "La Evaluación es obligatoria."
      };
    }

    return { success: resultado, mensaje: mensaje };
  };

  const clickCheck = () => {
    const validacion = isValid();
    if (validacion.success) {
      existeEvaluacion(formValues.Evaluacion);
    } else {
      setResult(validacion.mensaje);
      setCologMsg(COLOR_ERROR);
    }
  };

  // INICIO - BUSCAR 

  const QExisteEvaluacion = gql`
        query QExisteEvaluacion ($evaluacion: Int!) {
            existeEvaluacion
            (
                evaluacion: $evaluacion,
            ) 
            {
                success,
                error,
                valorEsperado
            }
        }`;

  const [getExisteEvaluacion, { data: dataEvaluacion, error: errorExisteEvaluacion }] = useLazyQuery(QExisteEvaluacion, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataEvaluacion) return;
    if (dataEvaluacion.existeEvaluacion.success) {
      const valor = dataEvaluacion.existeEvaluacion.valorEsperado;
      setResult(valor);
      if (valor === RESULTADO_VALIDACION_OK) {
        setDisabledBtnValidar(true);
        setCologMsg(COLOR_OK);

        // cargo si tiene un archivo ya asociado
        getDocumentoAsociado(parseInt(formValues.Evaluacion, 10));
      } else {
        setCologMsg(COLOR_ERROR);

        // limpio la grilla
        setData([]);
        setIdArchivo(0);
      }
    } else {
      setCologMsg(COLOR_ERROR);
      setResult("ERROR: no fue posible validar la Evaluación.");
      setMensajeError(dataEvaluacion.existeEvaluacion.error);
    }
  }, [dataEvaluacion]);

  useEffect(() => {
    if (!errorExisteEvaluacion) return;
    setCologMsg(COLOR_ERROR);
    setResult("ERROR: no fue posible validar la Evaluación.");
    setMensajeError("ERRORDB");
  }, [errorExisteEvaluacion]);

  const existeEvaluacion = (evaluacion) => {
    getExisteEvaluacion({ variables: { evaluacion: parseInt(evaluacion, 10), idConsulta: Math.random() } });
  };

  // FIN - BUSCAR     

  // INICIO - DOCUMENTO ASOCIADO 

  const QGetArchivo = gql`
       query QGetArchivo ($evaluacion: Int!) {
            archivoAutorizacion 
            (
                evaluacion: $evaluacion,
            ) 
            {
                success,
                error,
                valorEsperado {
                    idArchivo,
                    fechaAlta,
                    titulo,
                    contentType,
                    extension,
                    archivo
                } 
            }
        }`;

  const [getArchivoQuery, { data: dataFile, error: errorFile }] = useLazyQuery(QGetArchivo);

  useEffect(() => {
    if (!errorFile) return;
    toast.dismiss(toastId);
    setMensajeError("ERRORDB");
  }, [errorFile]);

  useEffect(() => {
    if (!dataFile) return;
    toast.dismiss(toastId);
    if (dataFile.archivoAutorizacion.success) {
      setShowGrilla(true);
      if (accion === 'VIEW') {
        setFilePreview(dataFile.archivoAutorizacion.valorEsperado[0]);
        setOpenDlg(true);
      }

      if (accion === 'DOWNLOAD') {
        const arr = new Uint8Array(dataFile.archivoAutorizacion.valorEsperado[0].archivo);
        const documento = new Blob([arr], { type: dataFile.archivoAutorizacion.valorEsperado[0].contentType });
        const fileName = dataFile.archivoAutorizacion.valorEsperado[0].titulo + dataFile.archivoAutorizacion.valorEsperado[0].extension;

        fileDownload(documento, fileName);
      }

      if (accion === 'BORRAR') {
        setIdArchivo(dataFile.archivoAutorizacion?.valorEsperado[0]?.idArchivo);
        setOpenDlgConfirm(true);
      }

    } else {
      setMensajeError(dataFile.archivoAutorizacion.error);
    }
  }, [dataFile]);

  const QGetTituloArchivoAutorizacion = gql`
        query QGetTituloArchivoAutorizacion ($evaluacion: Int!) {
            tituloArchivoAutorizacion
            (
                evaluacion: $evaluacion,
            ) 
            {
                success,
                error,
                valorEsperado {
                    idArchivo,
                    fechaAlta,
                    titulo,
                    contentType,
                    extension
                } 
            }
        }`;

  const [getDocumentoAsociadoQuery, { data: dataArchivo, error: errorArchivo }] = useLazyQuery(QGetTituloArchivoAutorizacion, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataArchivo) return;
    toast.dismiss(toastId);
    if (dataArchivo.tituloArchivoAutorizacion.success) {
      setShowGrilla(true);
      setData(dataArchivo.tituloArchivoAutorizacion.valorEsperado);
    } else {
      console.log(dataArchivo.tituloArchivoAutorizacion.error);
      setMensajeError(dataArchivo.tituloArchivoAutorizacion.error);
    };
  }, [dataArchivo]);

  useEffect(() => {
    if (!errorArchivo) return;
    toast.dismiss(toastId);
    setMensajeError("ERRORDB");
  }, [errorArchivo]);

  const getDocumentoAsociado = (evaluacion) => {
    setData([]);
    setIdArchivo(0);
    //toastId = toast.loading('Cargando...', { id: 'clipboard' });
    getDocumentoAsociadoQuery({ variables: { evaluacion: parseInt(evaluacion, 10), idConsulta: Math.random() } });
  };

  const getArchivo = (evaluacion) => {
    getArchivoQuery({ variables: { evaluacion: parseInt(evaluacion, 10), idConsulta: Math.random() } });
  };

  // FIN - DOCUMENTO ASOCIADO

  // INICIO - SUBIR DOCUMENTO

  const MSubirDocumentoAutorizacion = gql`
        mutation MSubirDocumentoAutorizacion (
            $evaluacion: Int!, $idTipoArchivo: Int!, $contentType: String!, $titulo: String!, $archivo: [Byte!]!, $extension: String!) {
            subirDocumentoAutorizacion
            (
                evaluacion: $evaluacion,
                idTipoArchivo: $idTipoArchivo,
                contentType: $contentType,
                titulo: $titulo,
                archivo: $archivo,
                extension: $extension,
            )
            {
                success,
                error,
                valorEsperado
            }
        }`;

  const [subirDocumento, { data: dataSubirDocumento }] = useMutation(MSubirDocumentoAutorizacion, {
    onCompleted: (dataSubirDocumento) => {
      if (dataSubirDocumento.subirDocumentoAutorizacion.success) {
        if (dataSubirDocumento.subirDocumentoAutorizacion.valorEsperado) {
          getDocumentoAsociado(parseInt(formValues.Evaluacion, 10));
        } else {
          toast.error(dataSubirDocumento.subirDocumentoAutorizacion.error);
        }
      } else {
        setMensajeError(dataArchivo.archivoAutorizacion.error);
      }
    },
    onError: (dataSubirDocumento) => {
      toast.dismiss(toastId);
      setMensajeError("ERRORDB");
    }
  });

  const handleChangeFile = (event) => {
    //toastId = toast.loading('Cargando...', { id: 'clipboard' });
    setShowGrilla(false);
    setFileSelected(event.target.files[0]);
    setIsFilePicked(true);
  };

  const isValidTipoArchivoAdjunto = () => {
    let sizeFile = fileSelected.size;
    if (sizeFile > APPCONFIG.SIZEARCHIVO.AUTORIZACION.SIZE) {
      return -1;
    }

    return APPCONFIG.TIPOADJUNTO.AUTORIZACION.some((e) => e === fileSelected.type);
  };

  useEffect(() => {
    if (isFilePicked) {
      let isValido = isValidTipoArchivoAdjunto();
      if (isValido > 0) {
        const reader = new FileReader();
        const fileByteArray = [];
        reader.readAsArrayBuffer(fileSelected);
        reader.onloadend = (evt) => {
          if (evt.target.readyState === FileReader.DONE) {
            const arrayBuffer = evt.target.result,
              array = new Uint8Array(arrayBuffer);
            for (const a of array) {
              fileByteArray.push(a);
            }

            subirDocumento({
              variables: {
                evaluacion: parseInt(formValues.Evaluacion, 10),
                idTipoArchivo: 16,
                titulo: fileSelected.name,
                contentType: fileSelected.type,
                extension: "." + fileSelected.name.split(".")[1],
                archivo: fileByteArray
              }
            });
          }
        };


      } else {
        setShowGrilla(true);
        isValido == 0 ? toast.error("El tipo de archivo adjunto no está permitido.") :
        toast.error("El tamaño del archivo adjunto no está permitido, su máximo permitido es: " + APPCONFIG.SIZEARCHIVO.AUTORIZACION.INFO);

      }
      setIsFilePicked(false);
    }
  }, [isFilePicked]);

  // FIN - SUBIR DOCUMENTO

  // INICIO - ELIMINAR DOCUMENTO

  const handleAceptarEliminar = () => {
    setOpenDlgConfirm(false);
    borrarDocumento({ variables: { idArchivo: parseInt(idArchivo, 10) } });
  };

  const handleCancelarEliminar = () => {
    setOpenDlgConfirm(false);
  };

  const MBorrarArchivoAutorizacion = gql`
        mutation MBorrarArchivoAutorizacion ($idArchivo: Int!) {
            borrarArchivoAutorizacion
            (
                idArchivo: $idArchivo
            )
            {
                success,
                error,
                valorEsperado
            }
        }`;

  const [borrarDocumento, { data: dataBorrarDocumento }] = useMutation(MBorrarArchivoAutorizacion, {
    onCompleted: (dataBorrarDocumento) => {
      if (dataBorrarDocumento.borrarArchivoAutorizacion.success) {
        // se eliminó el documento
        if (dataBorrarDocumento.borrarArchivoAutorizacion.valorEsperado) {
          setData([]);
          setIdArchivo(0);
        } else {
          toast.error(dataBorrarDocumento.borrarArchivoAutorizacion.error);
        }
      } else {
        setMensajeError(dataBorrarDocumento.borrarArchivoAutorizacion.error);
      }
    },
    onError: (dataBorrarDocumento) => {
      setMensajeError("ERRORDB");
    }
  });

  const handleBorrar = () => {
    setShowGrilla(false);
    setAccion('BORRAR');
    getArchivo(formValues.Evaluacion);
  };

  // FIN - ELIMINAR DOCUMENTO

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
    clickClear();
  };

  const clickClear = () => {
    setFormValues({
      Evaluacion: ''
    });
    textInputEvaluacion.current.focus();
    setResult("-");
    setDisabledBtnValidar(false);
    setShowGrilla(false);
  };

  const handleView = () => {
    setShowGrilla(false);
    setAccion('VIEW');
    getArchivo(formValues.Evaluacion);
  };

  const linkDescarga = () => {
    setShowGrilla(false);
    setAccion('DOWNLOAD');
    getArchivo(formValues.Evaluacion);
  };

  const initialColumns = [
  {
    field: 'idArchivo',
    headerName: 'Id'
  },
  {
    field: 'titulo',
    headerName: 'Nombre'
  },
  {
    field: 'fechaAlta',
    headerName: 'Fecha'
  },
  {
    field: 'actions', headerName: 'Acciones', sortable: false,
    renderCell: (params) =>
    <>
                    <VisibilityIcon
        sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt' }}
        onClick={() => handleView()}
        titleAccess='Visualizar' />
                    <DeleteOutlineIcon
        sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt', marginLeft: '15px' }}
        onClick={() => handleBorrar()}
        titleAccess='Borrar' />
                    <button onClick={() => linkDescarga()} style={{ border: 'none', background: 'none' }}>
                        <DownloadIcon
          sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt', marginLeft: '15px', paddingTop: '5px' }}
          titleAccess='Descargar' />
                    </button>
                </>

  }];


  const columns = generateColumnsDefaultConfiguration(initialColumns);

  return (
    <>
            <FormControl variant="outlined" sx={{ display: 'block', alignItems: 'center' }} fullWidth>
                <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center">

                    <div className="documento-encabezado" style={{ color: '#0063BE' }}>Autorizaciones</div>

                    <div>
                        <TextField
              className="input-40"
              inputRef={textInputEvaluacion}
              label="Evaluacion"
              name="Evaluacion"
              onChange={formHandle}
              required
              size="small"
              type="text"
              value={formValues.Evaluacion}
              variant="outlined" />
            
                    </div>
                    <br />
                    <div>
                        <CustomButton onClick={clickClear} variant="outlined">
                            Cancelar
                        </CustomButton>&nbsp;&nbsp;
                        <CustomButton disabled={disabledBtnValidar} onClick={clickCheck}>
                            Validar
                        </CustomButton>
                    </div>

                    <br />

                    <div style={{ display: 'flex', fontSize: '11pt', textAlign: 'center' }}>
                        <label style={{ fontWeight: 'bold', color: '#818181' }}>Origen: </label>&nbsp;
                        <label id="lblResul" style={{ color: colorMsg }}>{result}</label>
                    </div>

                    {showGrilla &&
          <>
                            <label htmlFor="icon-button-file">
                                <Input accept="image/jpeg,image/jpg,image/jfif,image/png,application/pdf,application/docx,application/doc" onChange={handleChangeFile} id="icon-button-file" type="file" />
                                <IconButton color="primary" aria-label="upload picture" component="span" size='large'>
                                    <CloudUploadIcon fontSize="inherit" />
                                </IconButton>
                            </label>
                            <div style={{ width: '100%' }}>
                                <DataGridGenerico
                id="DataRef"
                columns={columns}
                rows={data}
                toolbar={false}>
                
                                </DataGridGenerico>
                            </div>
                        </>
          }

                    {result === RESULTADO_VALIDACION_OK && !showGrilla &&
          <div class="loadingFullPage">
                            <div><CircularProgress disableShrink /><br />Cargando...</div>
                        </div>
          }


                </Grid>
            </FormControl>

            {openDlg && <DocumentViewer data={filePreview} setOpenDlg={setOpenDlg} />}

            <CustomDialog
        maxWidth="md"
        open={openDlgConfirm}
        title='Documento asociado'
        onCancel={handleCancelarEliminar}
        onAccept={handleAceptarEliminar}>
        
                ¿<strong>Está seguro de eliminar</strong> el documento seleccionado?
            </CustomDialog>

            <ErrorDialog
        id="dlg-error-autorizaciones"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      
        </>);

}